import { useState } from "react";
import { accountService, homeService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import { createUUID } from "@miplatform/utils";

export const useAccountDetailsViewModel = () => {
  const [accountDetail, setAccountDetail] = useState({});
  const [requiresPriceConfig, setRequiresPriceConfig] = useState({
    pricing: false,
    drops: false,
  });
  const [accountDraws, setAccountDraws] = useState([]);

  const stateManager = useComponentState();
  const GET_ACCOUNT_DETAILS_UUID = createUUID();
  const GET_ACCOUNT_DRAWS_UUID = createUUID();
  const GET_PRICING_REQUIRING_CONFIG_UUID = createUUID();

  const getAccountDetails = (id) => {
    stateManager.abort(GET_ACCOUNT_DETAILS_UUID);
    stateManager.run(async () => {
      const response = await accountService.accounts.getAccountById({ id });
      if (response.status === HTTP_STATUSES.OK) {
        setAccountDetail(response.data);
      }
    }, GET_ACCOUNT_DETAILS_UUID);
  };

  const getAccountDraws = (accountId) => {
    stateManager.abort(GET_ACCOUNT_DRAWS_UUID);
    stateManager.run(async () => {
      const response = await homeService.draws.getAll({
        accountId,
        sort: "displayOrder asc",
      });
      if (response.status === HTTP_STATUSES.OK) {
        setAccountDraws(response.data);
        await getDropsAndPricingConfig(accountId, response.data);
      }
    }, GET_ACCOUNT_DRAWS_UUID);
  };

  const getDropsAndPricingConfig = async (id, draws) => {
    if (draws.length === 0) {
      // if no draws are present, account requires initial setup
      setRequiresPriceConfig((prev) => ({ ...prev, pricing: true }));
    } else {
      getPricingRequiringConfig(id);
    }
  };

  const getPricingRequiringConfig = (accountId) => {
    stateManager.abort(GET_PRICING_REQUIRING_CONFIG_UUID);
    stateManager.run(async () => {
      const response = await homeService.accountPricing.getAll({
        accountId,
      });
      if (response.status === HTTP_STATUSES.OK) {
        setRequiresPriceConfig((prev) => ({
          ...prev,
          pricing: response.data.some((category) => category.drawTotal !== 100),
        }));
      }
    }, GET_PRICING_REQUIRING_CONFIG_UUID);
  };

  return {
    isLoading: stateManager.isBusy(),
    stateManager,
    accountDetail,
    setAccountDetail,
    getAccountDetails,
    requiresPriceConfig,
    setRequiresPriceConfig,
    getAccountDraws,
    accountDraws,
  };
};
